import { registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';

/**
 * Screens show money the way receipts do: ₹1,25,000, not ₹125,000.
 *
 * Only the digit grouping changes. Angular's real en-IN data would also turn PM into pm and Sep into Sept on every screen,
 * because IstPipe already asks for 'en-IN' and today falls back to English. So this is the English data with the Indian
 * number patterns, registered under that name.
 */
export const APP_LOCALE = 'en-IN';

const ENGLISH_NUMBER_PATTERN = '#,##0.###';
const INDIAN_NUMBER_PATTERNS = ['#,##,##0.###', '#,##,##0%', '¤#,##,##0.00', '#E0'];

export function registerIndianNumbers(): void {
  const data = (localeEn as unknown[]).map(part =>
    Array.isArray(part) && part[0] === ENGLISH_NUMBER_PATTERN ? INDIAN_NUMBER_PATTERNS : part);
  registerLocaleData(data, APP_LOCALE);
}

/** For sentences built in code. Same digits as before, grouped: ₹1,25,000 · ₹199.5 */
export function rupees(value: number | string | null | undefined): string {
  return '₹' + (Number(value) || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 });
}

/** Always paise, where the sentence used toFixed(2): ₹1,25,000.00 · ₹199.50 */
export function rupeesAndPaise(value: number | string | null | undefined): string {
  return '₹' + (Number(value) || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
